import { render } from "./UpdatePWA.vue?vue&type=template&id=4a4a64de"
import script from "./UpdatePWA.vue?vue&type=script&lang=js"
export * from "./UpdatePWA.vue?vue&type=script&lang=js"

import exportComponent from "/home/danidee/Dev/github/video-downloader-bot-pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QIcon,QBtn});
